import {
  CollectionName,
  FSUserPublicBookingViewSetting
} from '@WombatTechnology/nitte-time-lib'
import { store } from '@/firebase'
import {
  doc,
  collection,
  CollectionReference,
  DocumentData
} from 'firebase/firestore'

export class UserPublicBookingViewSetting {
  static doc(uid: string) {
    return doc<FSUserPublicBookingViewSetting, DocumentData>(
      this.collection(),
      uid
    )
  }

  static collection() {
    return collection(
      store,
      CollectionName.UserPublicBookingViewSettings
    ) as CollectionReference<FSUserPublicBookingViewSetting>
  }
}
